import { styled } from "@mui/material/styles"
import { Accordion, AccordionDetails, AccordionSummary, Box, Paper, Typography } from "@mui/material"

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3)
}))

export const StyledInspectionInfoBox = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "12px",
  boxShadow: "none"
}))

export const StyledInfoRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(1),
  "&:last-child": {
    marginBottom: 0
  }
}))

export const StyledInfoLabel = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.secondary,
  fontSize: theme.typography.body2.fontSize
}))

export const StyledInfoValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize
}))

export const StyledWarningBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: theme.palette.warning.light,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.warning.main}`,
  marginTop: theme.spacing(2)
}))

export const StyledWarningText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMedium
}))

export const StyledFormSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5)
}))

export const StyledSectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary
}))

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: "none",
  boxShadow: "none",
  margin: 0,
  "&:before": {
    display: "none"
  }
}))

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  margin: 0,
  padding: 0,
  marginBottom: theme.spacing(2),
  minHeight: "0 !important",
  "& .MuiAccordionSummary-content": {
    margin: 0
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    margin: 0
  }
}))

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: 0,
  marginLeft: 0,
  marginRight: 0,
  marginTop: 0,
  marginBottom: theme.spacing(3)
}))
